<script>
  import { createEventDispatcher } from "svelte";

  import Check from "$lib/assets/icons/check.svelte";
  import Markdown from "$lib/components/Markdown.svelte";

  export let id;
  export let name;
  export let label;
  export let required = false;
  export let defaultValue = false;
  export let error = "";
  export let binding;
  export let labelClass = "";
  export let errorLabelId;

  $: checked = defaultValue;
  let focus;

  function toggleFocus() {
    focus = !focus;
  }
  function toggleChecked() {
    checked = !checked;
  }

  const dispatch = createEventDispatcher();

  function handleChange() {
    dispatch("change", { value: binding.checked, name, id });
  }

  async function handleClick(ev) {
    await toggleChecked();
    handleChange(ev);
  }

  if (required) {
    label = `${label} (Required)`;
  }
</script>

<div
  class="flex align-middle pb-0 rounded-5 items-center focus-within:border-none focus-within:ring-2 focus-within:ring-cyan-700 focus-within:bg-cyan-50"
>
  <input
    {id}
    bind:this={binding}
    bind:checked
    on:focus={toggleFocus}
    on:blur={toggleFocus}
    type="checkbox"
    {name}
    class="text-size-14 w-full h-2 border absolute opacity-0"
    {required}
    aria-invalid={!!error}
    aria-describedby={error ? errorLabelId : null}
    on:change={handleChange}
  />

  <!-- svelte-ignore a11y-no-static-element-interactions -->
  <!--svelte-ignore a11y-click-events-have-key-events -->
  <span
    class="w-16 h-16 border mr-10 rounded-5 {error ? 'border-error' : ''}"
    class:bg-cyan-600={checked && focus}
    on:click={handleClick}
  >
    {#if checked}
      <Check class="w-full" currentColor={focus ? "var(--color-white)" : "currentColor"} />
    {/if}
  </span>
  <label for={id} class="text-size-14 lg:text-size-16 {labelClass}">
    <Markdown input={label} class="rich-text-paragraph" />
  </label>
</div>
